/* NPM */
import React, { useCallback, useRef, useState } from 'react';
import { Portal } from 'react-portal';
/* COMPONENTS */
import {
  Button,
  MDIIcon,
  useOnClickInsideOutside,
  useWindowSize,
} from '@solinkcorp/solink-components';
/* STYLES */
import './ReceiptPopover.sass';
/* Hooks */
import Receipt from '@mdi/svg/svg/receipt.svg?react';
import useLocale from 'src/hooks/useLocale';
const BUTTON_WIDTH = 32;
const SAVE_PANEL_PADDING = 1.3;
const RECEIPT_MARGIN = 1;

interface ReceiptPopoverProps {
  receipt?: string;
}

const ReceiptPopover: React.FC<ReceiptPopoverProps> = (props) => {
  const { receipt } = props;
  const windowSize = useWindowSize();
  const locale = useLocale();
  const buttonRef = useRef<HTMLElement | null>(null);
  const receiptRef = useRef<HTMLDivElement | null>(null);
  const [receiptTop, setReceiptTop] = useState(0);
  const [receiptLeft, setReceiptLeft] = useState(0);
  const [maxHeight, setMaxHeight] = useState(0);
  const [isReceiptOpen, setIsReceiptOpen] = useState(false);

  const getNodePosition = (node: HTMLElement) => node.getBoundingClientRect();

  const updateReceiptPosition = useCallback(
    (node: HTMLElement | null) => {
      if (node) {
        const { top, left, y } = getNodePosition(node);
        setReceiptTop(top + BUTTON_WIDTH);
        setReceiptLeft(left + BUTTON_WIDTH);
        setMaxHeight(windowSize.height - y);
      }
    },
    [windowSize.height],
  );

  const setButtonRef = useCallback(
    (node: HTMLElement) => {
      buttonRef.current = node;

      if (node) {
        updateReceiptPosition(node);
      }
    },
    [updateReceiptPosition],
  );

  useOnClickInsideOutside(
    receiptRef,
    (isInside) => {
      if (!isInside) {
        setIsReceiptOpen(false);
      }
    },
    {},
    buttonRef,
  );

  return (
    <div className="receipt-popover">
      <Button
        className="receipt-button"
        icon={<MDIIcon icon={Receipt} fill="var(--color-green)" />}
        onClick={() => {
          setIsReceiptOpen(!isReceiptOpen);
          updateReceiptPosition(buttonRef.current);
        }}
        refFunc={setButtonRef}
        text={locale.cloudShare.viewFullReceipt}
        type="clear"
        typography="regular"
      />
      {isReceiptOpen && (
        <Portal>
          <div
            ref={receiptRef}
            className="save-panel-receipt"
            style={{
              top: receiptTop,
              left: receiptLeft,
              maxHeight: `calc(${maxHeight}px - ${SAVE_PANEL_PADDING}em - ${RECEIPT_MARGIN}em)`,
            }}
          >
            <pre>{receipt}</pre>
          </div>
        </Portal>
      )}
    </div>
  );
};

export default ReceiptPopover;
